import React, { useEffect, useState } from "react";
import { MdInfo } from "react-icons/md";
import MessageItem from './MessageItem';
import "./Conversation.css";
import { getLeads, getDealerLeads, triggerCaptureLead, triggerCaptureActivix, triggerCaptureADF, deleteConversation, sendEmailTool } from '../services/api';

const AUTHORIZATION = process.env.REACT_APP_API_AUTH_KEY;

function Modal({ isOpen, onClose, onSubmit }) {
    const [leadName, setLeadName] = useState('');
    const [leadEmail, setLeadEmail] = useState('');
    const [leadPhone, setLeadPhone] = useState('');
    const [selectedTool, setSelectedTool] = useState('captureLead');
    const [eventType, setEventType] = useState('phone_appointment'); // Default value

    // Calculate the event date to be 9 AM, 4 days from today
    const calculateEventDate = () => {
        const date = new Date();
        date.setDate(date.getDate() + 4);
        date.setHours(9, 0, 0, 0); // Set time to 9 AM

        // Manually format the date to exclude timezone information
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    };

    const eventDate = calculateEventDate();

    if (!isOpen) return null;

    const handleSubmit = () => {
        onSubmit({
            name: leadName,
            email: leadEmail,
            phone: leadPhone || null,
            tool: selectedTool,
            eventType,
            eventDate
        });
        onClose();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Enter Lead Details</h2>
                <input
                    type="text"
                    placeholder="Lead Name"
                    value={leadName}
                    onChange={(e) => setLeadName(e.target.value)}
                />
                {selectedTool === 'captureLead' && (
                    <input
                        type="email"
                        placeholder="Lead Email"
                        value={leadEmail}
                        onChange={(e) => setLeadEmail(e.target.value)}
                    />
                )}
                <input
                    type="text"
                    placeholder="Lead Phone"
                    value={leadPhone}
                    onChange={(e) => setLeadPhone(e.target.value)}
                />
                <select value={selectedTool} onChange={(e) => setSelectedTool(e.target.value)}>
                    <option value="captureLead">Capture Lead</option>
                    <option value="captureActivix">Capture Activix</option>
                    <option value="captureADF">Capture ADF</option>
                </select>
                {selectedTool === 'captureActivix' && (
                    <select value={eventType} onChange={(e) => setEventType(e.target.value)}>
                        <option value="phone_appointment">Phone Appointment</option>
                        <option value="appointment">In-Person Appointment</option>
                    </select>
                )}
                <button onClick={handleSubmit}>Submit</button>
                <button onClick={onClose}>Cancel</button>
            </div>
        </div>
    );
}

function EmailModal({ isOpen, onClose, onSubmit, threadId }) {
    const [leadName, setLeadName] = useState('');
    const [leadEmail, setLeadEmail] = useState('');
    const [leadPhone, setLeadPhone] = useState('');
    const [toEmail, setToEmail] = useState('');

    if (!isOpen) return null;

    const handleSubmit = () => {
        if (leadName.trim() && toEmail.trim()) {
            onSubmit({
                leadName: leadName.trim(),
                threadId,
                toEmail: toEmail.trim(),
                leadPhone: leadPhone.trim() || null,
                leadEmail: leadEmail.trim() || null
            });
            onClose();
            // Reset form
            setLeadName('');
            setLeadEmail('');
            setLeadPhone('');
            setToEmail('');
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Send Email</h2>
                <input
                    type="text"
                    placeholder="Lead Name *"
                    value={leadName}
                    onChange={(e) => setLeadName(e.target.value)}
                    required
                />
                <input
                    type="email"
                    placeholder="Lead Email (optional)"
                    value={leadEmail}
                    onChange={(e) => setLeadEmail(e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Lead Phone (optional)"
                    value={leadPhone}
                    onChange={(e) => setLeadPhone(e.target.value)}
                />
                <input
                    type="email"
                    placeholder="To Email *"
                    value={toEmail}
                    onChange={(e) => setToEmail(e.target.value)}
                    required
                />
                <button onClick={handleSubmit} disabled={!leadName.trim() || !toEmail.trim()}>Submit</button>
                <button onClick={onClose}>Cancel</button>
            </div>
        </div>
    );
}

export default function ConversationItem(props) { 
    const { displayed, onDelete } = props;
    const [leads, setLeads] = useState([]);
    const [leadTrigger, setLeadTrigger] = useState("No");
    const [errors, setErrors] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [isEmailModalOpen, setEmailModalOpen] = useState(false);

    useEffect(() => {
        const fetchLeads = async (clientId, assistantId) => {
            try {
              const v1leads = await getLeads(clientId);
              const v2leads = await getDealerLeads(assistantId);
              setLeads([...v1leads.data, ...v2leads.data]);
            } catch (error) {
                setErrors(prevErrors => [...prevErrors, 'Error fetching leads']);
            }
        };
        fetchLeads(displayed.client_id, displayed.assistant_id);
    }, [displayed.client_id, displayed.assistant_id]);

    useEffect(() => {
        let found = false;
        leads.forEach(lead => {
            if (lead.id === displayed.thread_id) {
                setLeadTrigger("Yes");
                found = true;
            }
        });
        if (!found) {
            setLeadTrigger("No");
        }
    }, [leads, displayed.thread_id]);

    const handleTriggerTool = async (leadDetails) => {
        const { email, name, phone, tool, eventType, eventDate } = leadDetails;

        try {
            if (tool === 'captureLead') {
                await triggerCaptureLead(email, name, phone, displayed.assistant_id, displayed.thread_id, AUTHORIZATION);
            } else if (tool === 'captureActivix') {
                await triggerCaptureActivix(
                    phone, // leadPhone
                    name,  // leadName
                    displayed.assistant_id, // assistantId
                    displayed.thread_id,    // threadId
                    eventType,              // eventType
                    eventDate               // eventDate
                );
            } else if (tool === 'captureADF') {
                await triggerCaptureADF(
                    phone, // leadPhone
                    name,  // leadName
                    displayed.assistant_id, // assistantId
                    displayed.thread_id     // threadId
                );
            }
        } catch (error) {
            setErrors(prevErrors => [...prevErrors, 'Error triggering tool']);
        }
    };

    const handleSendEmail = async (emailDetails) => {
        const { leadName, threadId, toEmail, leadPhone, leadEmail } = emailDetails;
        try {
            await sendEmailTool(leadName, threadId, toEmail, leadPhone, leadEmail);
        } catch (error) {
            setErrors(prevErrors => [...prevErrors, 'Error sending email']);
        }
    };

    const handleDeleteConversation = async () => {
        if (window.confirm('Are you sure you want to delete this conversation?')) {
            try {
                await deleteConversation(displayed.thread_id);
                if (onDelete) {
                    onDelete(displayed.thread_id);
                }
            } catch (error) {
                setErrors(prevErrors => [...prevErrors, 'Error deleting conversation']);
            }
        }
    };

    if (errors.length > 0) return <div className="error">{errors.join('. ')}</div>;

    if (displayed.source) {
        if (displayed.source.url === "no source url found") {
            displayed.source.url = "sandbox";
        }
    }

    return (
        <div className='selected-conversation-container'>
            <div className='selected-conversation-infos'>
                <MdInfo style={{float: 'right', width: '20px', height: '20px'}} color='inherit'/>
                <button
                    style={{ float: 'right', marginTop: '30px', marginRight: '10px' }}
                    onClick={() => setModalOpen(true)}
                >
                    Trigger Tool
                </button>
                <button
                    style={{ float: 'right', marginTop: '30px', marginRight: '10px', backgroundColor: '#28a745', color: 'white' }}
                    onClick={() => setEmailModalOpen(true)}
                >
                    Send Email
                </button>
                <button
                    style={{ float: 'right', marginTop: '30px', backgroundColor: '#dc3545', color: 'white' }}
                    onClick={handleDeleteConversation}
                >
                    Delete Conversation
                </button>
                <p>ID : {displayed.thread_id}</p>
                <p>Assistant : {displayed.assistant_id}</p>
                <p>Model : {displayed.model || '—'}</p>
                <p>Instructions : {displayed.instructions_id || '—'}</p>
                <p>Device : {displayed.source ? displayed.source.device : 'N/A'}</p>
                <p>Source : {displayed.source ? displayed.source.url : 'N/A'}</p>
                <p>Lead Trigger : {leadTrigger}</p>
            </div>

            <div className='selected-conversation-content'>
                {displayed.messages.map(message => (
                    <div key={message.message_id}>
                        <MessageItem bubble={message} />
                    </div>
                ))}
            </div>

            <Modal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                onSubmit={handleTriggerTool}
            />
            <EmailModal
                isOpen={isEmailModalOpen}
                onClose={() => setEmailModalOpen(false)}
                onSubmit={handleSendEmail}
                threadId={displayed.thread_id}
            />
        </div>
    );
}